export default __webpack_public_path__ + "static/media/login_microsoft_branco.ee5d8b50.svg";